import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

const cursor = document.querySelector('.cursor');

document.addEventListener('mousemove', e => {
    cursor.setAttribute("style", "top: " + (e.pageY - 10) + "px; left: " + (e.pageX - 10) + "px;")
})
document.addEventListener('click', () => {
    cursor.classList.add("expand");

    setTimeout(() => {
        cursor.classList.remove("expand");
    }, 500)
})

gsap.from('.logo__accueil',{
    duration: 1,
    opacity: 0,
    delay: 0.25,
    scrollTrigger: {
        trigger: ".logo__accueil",
        toggleActions: "restart none restart none"
    },
})
gsap.from(".concept__titre",{
    x: -70,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".concept__titre",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".concept__photo",{
    y: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".concept__titre",
        start: "center 70%",
        end:"center 50%",
    },
})


gsap.from(".concept__texte",{
    x: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".concept__titre",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".visite--photo",{
    x: -50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".visite--photo",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".visite__titre-texte h2",{
    y: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".visite--photo",
        start: "center 80%",
        end:"center 50%",
    },
})
gsap.from(".visite__titre-texte p",{
    y: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".visite--photo",
        start: "center 90%",
        end:"center 50%",
    },
})
gsap.from(".expose__photo--anim",{
    y: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".expose__photo--anim",
        start: "center 90%",
        end:"center 50%",
    },
})
gsap.from(".expose__titre-texte--anim",{
    x: 50,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".expose__titre-texte--anim",
        start: "center 90%",
        end:"center 50%",
    },
})
gsap.from(".apropos__titre",{
    x: -70,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".apropos__titre",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".apropos__texte",{
    y: 70,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".apropos__texte",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".concept__titre-photo h1",{
    x: -70,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".concept__titre-photo h1",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".concept__titre-photo img",{
    y: -30,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".concept__titre-photo img",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".visite__titre-texte",{
    x: -30,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".visite__titre-texte",
        start: "center 70%",
        end:"center 50%",
    },
})
gsap.from(".content__scroll",{
    opacity: 0,
    duration: 2,
    scrollTrigger: {
        trigger: ".content__scroll",
        start: "center 80%",
        end: "center 50%",
    },
})
gsap.from(".visite__photo",{
    x: -30,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".visite__photo",
        start: "center 80%",
        end: "center 50%",
    },
})
gsap.from(".expose__titre-texte",{
    y: 30,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".expose__titre-texte",
        start: "center 80%",
        end: "center 50%",
    },
})
gsap.from(".expose__photo",{
    x: 30,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
        trigger: ".expose__photo",
        start: "center 80%",
        end: "center 50%",
    },
})
gsap.from(".apropos__titre-texte",{
    opacity: 0,
    duration: 2,
    scrollTrigger: {
        trigger: ".apropos__titre-texte",
        start: "center 80%",
        end: "center 50%",
    },
})








